import React from "react";
import connect from "react-redux/es/connect/connect";
import { Translate } from "react-localize-redux";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { NavLink } from "react-router-dom";
import "./styles.scss";

class BrandButton extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    return (
      <Dropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
        className="brand-button-container"
      >
        <DropdownToggle tag={"h3"}>
          <span id="brand-flex-container">
            <span id="brand-shrink-my">my</span>
            <span id="brand-btn-text">HelloHello</span>
            <span className="fas fa-caret-down brand-caret" />
          </span>
        </DropdownToggle>
        <DropdownMenu>
          <ul className="brand-dropdown-list">
            <li>
              <div className="brand-text-container">
                <p className="brand-text">
                  <Translate id="cardText1" />
                </p>
                <p className="brand-text">
                  <Translate id="cardText2" />
                </p>
              </div>
            </li>
            <li className="brand-text">
              <i className="fa fa-check brand-check" />{" "}
              <Translate id="freeText" />
            </li>
            <li className="brand-text">
              <i className="fa fa-check brand-check" />{" "}
              <Translate id="controlText" />
            </li>
            <li className="brand-text">
              <i className="fa fa-check brand-check" />{" "}
              <Translate id="getText" />
            </li>
          </ul>

          {!this.props.loggedIn && (
            <div className="BrandButton__signup_btn_container">
              <NavLink to="/register" className="btn btn-primary">
                <Translate id="signUpText" />
              </NavLink>
            </div>
          )}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ loggedIn: auth.loggedIn });

export default connect(mapStateToProps)(BrandButton);



// WEBPACK FOOTER //
// ./src/components/BrandButton/BrandButton.jsx